import App from '@/components/App';
import Home from '@/components/Home';

import Sandbox from '@/components/Sandbox';

export default
[
	{
		path: '/',
		name: 'Home',
		component: Home,
	},
	{
		path: '/!/:clientKey',
		redirect: '/init/:clientKey'
	},
	{
		path: '/init/:clientKey',
		name: 'Init-ClientKey'
	},
	{
		path: '/!/:clientKey/:userToken',
		redirect: '/init/:clientKey/:userToken'
	},
	{
		path: '/init/:clientKey/:userToken',
		name: 'Init-ClientKey-UserToken'
	},
	{
		path: '/enrollment/:enrollmentUUID',
		name: 'Enrollment',
		component: Home
	},
	{
		path: '/enrollment/:enrollmentUUID/sandbox/:sandboxUUID',
		name: 'Sandbox',
		component: Sandbox
	}
];
